import GoogleTagManager from './GoogleTagManager'

export default GoogleTagManager



// WEBPACK FOOTER //
// ./src/gtm/index.js